const FranchiseSummary = () => import('@/modules/franchiseSummary');

export default [
  {
    path: '/franquia',
    name: 'franchise-root',
    redirect: { name: 'list-stores', },
  },
  {
    path: '/franquia/resumo',
    name: 'franchise-summary',
    component: FranchiseSummary,
    meta: {       
      isAvaliableInMenu: false,
      navbarTitle: 'Resumo',
      menuData: {
        title: 'Resumo',
        id: 'franchiseSummarySidebar',
      },
    },
  },
];
